export default __webpack_public_path__ + "static/media/submit.6f3a1d30.svg";